module.exports = __webpack_public_path__ + "static/media/cf_temp_logo.2317e63f.png";